export default __webpack_public_path__ + "static/media/img_scsc_14.332bf9ad.png";